<script setup lang="ts">
  import { MpDivider, MpIcon, MpMenu, MpText } from '@borg/ui';

  const sidebar = leftSidebar.inject();
</script>

<template>
  <MpMenu>
    <LinksLocale
      to="jobs"
      data-test="HEADER_WIDGETS.SEARCH_JOBS"
      @click="sidebar.toggle"
    >
      {{ $t('HEADER_WIDGETS.SEARCH_JOBS') }}
    </LinksLocale>
    <LinksLocale
      to="employers"
      data-test="HEADER_WIDGETS.EMPLOYER_PROFILES"
      @click="sidebar.toggle"
    >
      {{ $t('HEADER_WIDGETS.EMPLOYER_PROFILES') }}
    </LinksLocale>
    <LinksLocale
      to="calculator-salary"
      data-test="HEADER_WIDGETS.MONEY_TOOLS"
      @click="sidebar.toggle"
    >
      {{ $t('HEADER_WIDGETS.MONEY_TOOLS') }}
    </LinksLocale>
    <LinksLocale
      to="advices"
      data-test="HEADER_WIDGETS.ADVICES"
      @click="sidebar.toggle"
    >
      {{ $t('HEADER_WIDGETS.ADVICES') }}
    </LinksLocale>
    <MpDivider margin="sm" />
    <LinksLocale
      class="external-link"
      to="https://poslodavci.mojposao.hr/"
      target="_blank"
      data-test="HEADER_WIDGETS.FOR_EMPLOYERS"
      @click="sidebar.toggle"
    >
      <MpText link-plain>
        {{ $t('HEADER_WIDGETS.FOR_EMPLOYERS') }}
      </MpText>
      <MpIcon
        class="external-link__icon"
        icon="new_window"
        size="sm"
      />
    </LinksLocale>
  </MpMenu>
</template>

<style scoped lang="scss">
  .external-link {
    display: flex;
    align-items: center;
    gap: var(--mp-space-30);

    &__icon {
      color: var(--mp-color-secondary-default);
      @include dark-mode {
        color: var(--mp-color-secondary-light);
      }
    }
  }
</style>
